import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-message-blue",
  "use": "icon-message-blue-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-message-blue\"><defs><style type=\"text/css\"></style></defs><path d=\"M643.657 490.057a36.571 36.571 0 1 0 73.143 0 36.571 36.571 0 1 0-73.143 0zM321.829 490.057a36.571 36.571 0 1 0 73.142 0 36.571 36.571 0 1 0-73.142 0zM482.743 490.057a36.571 36.571 0 1 0 73.143 0 36.571 36.571 0 1 0-73.143 0z\" fill=\"#67BAFF\" p-id=\"2994\" /><path d=\"M512 0C229.669 0 0 229.669 0 512s229.669 512 512 512 512-229.669 512-512S794.331 0 512 0z m277.943 570.514c0 49.737-38.034 87.772-87.772 87.772H434.47L313.05 716.8c-1.462 1.463-4.388 1.463-7.314 1.463-8.777-1.463-14.628-8.777-13.166-16.092l5.852-43.885h-5.852c-32.182 0-58.514-26.332-58.514-58.515v-204.8c0-49.737 38.034-87.771 87.772-87.771H702.17c49.738 0 87.772 38.034 87.772 87.771v175.543z\" fill=\"#67BAFF\" p-id=\"2995\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/message-blue.svg
// module id = Jqo0
// module chunks = 65